var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5251_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 150L10.3447 112.5C3.6208 100.862 0 87.9311 0 74.4826C0 33.6208 33.6208 0 74.7413 0C115.862 0 150 33.6208 150 74.4826C150 115.344 115.862 150 74.7413 150C61.8103 150 49.3966 145.862 38.2758 139.655L0 150Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3453 126.207L42.6729 127.5C52.2419 133.448 63.3627 137.069 75.0006 137.069C108.88 137.069 137.07 108.879 137.07 74.4827C137.07 40.0861 108.88 12.9312 74.7419 12.9312C40.604 12.9312 12.9316 40.3448 12.9316 74.4827C12.9316 86.3793 16.2938 98.0172 22.5006 107.845L24.0524 110.172L18.1043 131.897L40.3453 126.207Z",
    fill: "#55CD6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8267 39.8275L49.913 39.5688C48.3612 39.5688 46.8096 40.0862 45.7751 41.1207C43.4475 43.1896 39.5683 47.0688 38.5338 52.2415C36.7236 60.0002 39.5683 69.3105 46.2925 78.6207C53.0167 87.931 65.9478 102.931 88.7062 109.396C95.9475 111.465 101.637 110.172 106.293 107.328C109.913 105 112.241 101.379 113.017 97.4999L113.793 93.8791C114.051 92.8446 113.534 91.5515 112.499 91.0344L96.2062 83.5344C95.1717 83.017 93.8786 83.2757 93.1028 84.3102L86.6373 92.5859C86.1199 93.1033 85.3441 93.3617 84.5683 93.1033C80.1717 91.5515 65.4304 85.3446 57.413 69.8275C57.1543 69.0518 57.1543 68.2757 57.6717 67.7586L63.8786 60.776C64.3959 60.0002 64.6543 58.9657 64.3959 58.1897L56.8959 41.3794C56.637 40.6033 55.8612 39.8275 54.8267 39.8275Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5251_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.01caaa8da72aaa360989eab7ec867375.svg";
export { ForwardRef as ReactComponent };